module.exports = __webpack_public_path__ + "img/uav.c87a50b7.png";